
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { selectFile } from '@/utils/FileApis'
import { uuid } from '@/utils/uuid'
import { IFileList } from '@/types/placeOrderTypes'
import { ServiceContentEnum } from '@/business/ServiceContent'

@Component
export default class BaseUpload extends Vue {
  @Prop({ required: true }) title!: string
  @Prop({ default: false }) checking!: boolean
  @Prop({ default: () => [] }) fileList!: any[]

  @Prop({ default: () => ['zip'] }) regText!: string[]
  @Prop({ default: 'zipList' }) targetList!: string
  @Prop({ default: '.zip' }) accept!: string
  @Prop({ default: true }) multiple!: boolean
  @Prop({ default: 'zip' }) fileType!: string
  @Prop({}) selectFileType!: number

  @Prop({}) files!: IFileList[]

  @Emit('file-selected')
  async selectFile() {
    return new Promise(resolve => {
      selectFile(
        {
          accept: this.accept,
          multiple: this.multiple,
        },
        async files => {
          if (this.selectFileType === ServiceContentEnum.WordToFbd_auto && this.fileType === 'word') {
            files = files.filter(f => {
              return f.size < 30 * 1024 * 1024
            })
            if (!files.length) {
              this.$message.warning('请上传小于 30M 的 WORD 文件！')
              return resolve([])
            }
          }

          if (files.some(file => !/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(file.name))) {
            this.$message.warning('存在非法字符\\ / : * ? " < > | \' ')
            return resolve([])
          }
          // Filter files by extension
          files = files.filter(f => {
            return this.regText.some(i => new RegExp(`.${i}$`, 'i').test(f.name))
          })

          if (!files.length) {
            this.$message.warning(`请上传以${this.accept}后缀格式文件！`)
            return resolve([])
          }

          files = files.filter(f => {
            return (
              // @ts-ignore
              !this.files.filter(item => item[this.fileType as keyof IFileList] && item[this.fileType]!.name === f.name)
                .length &&
              !this.fileList.filter(item => item[this.fileType] && f.name === item[this.fileType]!.name).length
            )
          })
          // Check file size
          if (files.length && files.reduce((acc, cur) => acc + cur.size, 0) > 1024 * 1024 * 1024 * 4) {
            this.$message.warning('上传文件总大小不能超过 4G')
            return resolve([])
          }

          const processedFiles = []

          for (const file of files) {
            const item = {
              id: uuid(),
              status: 'checking',
              checkInfo: '',
              uploadInfo: '',
              progress: 0,
            } as any

            if (this.selectFileType === 3) {
              if (
                files.some(item => item.type === 'body') ||
                this.files.filter(item => item.pdf).some(item => item.type === 'body')
              )
                item.type = 'answer'
              else item.type = 'body'
            }
            this.files.push(item)
            item[this.fileType] = file

            processedFiles.push(item)
          }
          resolve(processedFiles)
        },
      )
    })
  }
}
